import PropTypes from 'prop-types';

export default {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.number,
  kind: PropTypes.string,
  number: PropTypes.string,
  billable_document_id: PropTypes.number,
  billable_document_name: PropTypes.string,
  signed_document_id: PropTypes.number,
  signed_document_name: PropTypes.string,
  invoice_status: PropTypes.string,
  invoice_number: PropTypes.string,
  errors: PropTypes.shape({
    total: PropTypes.array,
    kind: PropTypes.array,
    number: PropTypes.array,
  }),
};

const purchaseOrderOptionsType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}));

export { purchaseOrderOptionsType };



// WEBPACK FOOTER //
// ./client/app/shared/types/purchaseOrder.js